export const getYesNoIcon = (value: boolean) =>
  value ? (
    <i className='fa-solid fa-circle-check' style={{ color: '#43c75d' }} />
  ) : (
    <i className='fa-solid fa-circle-xmark' style={{ color: '#ff0000' }} />
  );
